export default function ErrorTest(): never {
  throw new Error('Test error — checking error boundary');
}
